import slipSagas from './slipSagas';
export default slipSagas;
